import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SfMinusCircleFillIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 22 22",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 11.004C22 17.017 17.017 22 10.996 22 4.983 22 0 17.017 0 11.004 0 4.983 4.974 0 10.987 0 17.01 0 22 4.983 22 11.004Zm-17-.136c0 .528.394.842.958.842h9.677c.564 0 .958-.314.958-.842 0-.546-.367-.868-.958-.868H5.958c-.582 0-.958.322-.958.868Z",
    clipRule: "evenodd"
  })
});
export default SfMinusCircleFillIcon;